import {
  DetailedDrop_LiveShow,
  DetailedDrop_LiveShow_LiveShowState as LiveShowState,
} from '@aboutyou/legacy-shared/src/grpc_client/grips/protos/shared/detailed_drop'
import { useTranslation } from 'helpers/hooks/useTranslation'
import React from 'react'
import styled, { css } from 'styled-components'
import Button from 'uiComponents/atoms/Buttons/Button'
import { Icon, IconSize } from 'uiComponents/atoms/Icon/Icon'
import { IconName } from 'uiComponents/atoms/Icon/IconName'
import { primaryColor } from 'uiComponents/constants/colors'

export const LiveShowStartButton: React.FC<{
  liveShow: DetailedDrop_LiveShow
  startLiveShow: (showId: string) => void
}> = ({ liveShow, startLiveShow }) => {
  const { t } = useTranslation()

  if (!liveShow) {
    return null
  }

  const buttonLabel = () => {
    switch (liveShow.state) {
      case LiveShowState.LIVE_SHOW_STATE_NOT_STARTED:
        return t('Erinnere mich')
      case LiveShowState.LIVE_SHOW_STATE_LIVE:
        return t('Livestream anschauen')
      case LiveShowState.LIVE_SHOW_STATE_ENDED:
        return t('Erneut abspielen')
      default:
        return ''
    }
  }

  const buttonIcon = () => {
    return [
      LiveShowState.LIVE_SHOW_STATE_LIVE,
      LiveShowState.LIVE_SHOW_STATE_ENDED,
    ].includes(liveShow.state)
      ? IconName.IcPlayCircle
      : IconName.IcBell
  }

  return (
    <GoToLiveShow
      data-testid="LiveShow-StartButton"
      onClick={() => startLiveShow(liveShow.id)}
      $liveShowState={liveShow.state}
    >
      <StyledButtonIcon asset={buttonIcon()} size={IconSize.S} />
      {buttonLabel()}
    </GoToLiveShow>
  )
}

const GoToLiveShow = styled(Button)<{
  $liveShowState: LiveShowState
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0.3;
  border-radius: 3px;
  padding: 14px 60px;
  color: ${primaryColor};

  ${({ $liveShowState }) =>
    $liveShowState === LiveShowState.LIVE_SHOW_STATE_LIVE
      ? css`
          background-color: #f9ff00;
        `
      : css`
          background-color: transparent;
          border: 1px solid ${primaryColor};
        `}
`

const StyledButtonIcon = styled(Icon)`
  margin-right: 4px;
`
